import { useParams } from 'react-router';
import { useGetPassPurchaseQuery } from 'drycut-graphql';
import { PassDetails } from 'booking/components';
import { useDocumentTitle } from 'usehooks-ts';
import { Loader } from 'ui-components';

export function PassDetailsByUid(): React.ReactElement {
  useDocumentTitle('DRYCUT - DRYPASS');

  const { slug, uid } = useParams() as { slug: string; uid: string };
  const { data, loading } = useGetPassPurchaseQuery({ variables: { uid } });

  if (loading) {
    return <Loader />;
  }

  return <PassDetails storeSlug={slug} passPurchase={data?.passPurchase} manual />;
}
